import React from 'react';

const RequiredMark = () => (
  <span className="required-mark" aria-label="필수" title="필수">
    *
  </span>
);

export const TitleWithRequired = ({ title, required }) => (
  <>
    {title}
    {required ? <RequiredMark /> : null}
  </>
);

export default RequiredMark;
